<template>
  <div>
    <div
      class="results-wrapper"
      :class="{ loading: loading }"
      ref="grid"
      :key="rkey"
    >
      <router-link
        v-for="(item, index) in sortedItems"
        v-bind:title="item.title"
        v-bind:key="item.id"
        :to="item.path + '/' + item.id"
        class="img-link"
      >
        <img
          v-if="item.img_url"
          :src="item.img_url"
          :class="item.img_class"
          :alt="item.title"
          @load="imgLoaded(item.id)"
        />
      </router-link>

      <div class="box-wrapper" ref="bw">
        <div class="last-column"></div>
      </div>
    </div>
    <div class="o-malleys-bar"></div>
    <pagination
      v-if="total && loading == false"
      :options="counter_options"
      v-model="current_page"
      :records="Number(total)"
      :per-page="30"
      @paginate="changePage()"
    />
  </div>
</template>

<script>
import Pagination from "vue-pagination-2";
import GridPagination from "@/components/Common/Grid/GridPagination.vue";
import { eventBus } from "@/main.js";

export default {
  name: "Grid",
  props: ["items", "total", "page", "title"],
  components: {
    Pagination,
    GridPagination,
  },
  data() {
    return {
      rkey: Math.random(),
      current_page: Number(this.page),
      loading: true,
      images: null,
      localItems: [],
      counter_options: {
        chunk: 5,
        texts: {
          count: "Wyświetlono linki: {from}-{to}/{count}.|Linków: {count}|",
          first: "Pierwsza",
          last: "Ostatnia",
        },
        format: false,
        edgeNavigation: false,
        template: GridPagination,
      },
    };
  },
  computed: {
    sortedItems() {
      if (!this.localItems || !this.localItems.length) return [];
      if (this.$route.name === "Collection") {
        return [...this.localItems].sort((a, b) => a.order - b.order);
      } else {
        return [...this.localItems].sort((a, b) => b.id - a.id);
      }
    },
  },
  watch: {
    items: {
      handler(newItems) {
        this.localItems = [...newItems]; // tylko kopia, nie mutujemy props
      },
      immediate: true,
    },
    $route() {
      if (typeof this.$router.currentRoute.params.page === "undefined") {
        this.current_page = Number(1);
      } else {
        this.current_page = Number(this.$router.currentRoute.params.page);
      }
      this.gridRefresh();
    },
  },
  mounted() {
    eventBus.$on("plsResetGrid", () => {
      this.$refs.bw.innerHTML = "";
      this.$refs.bw.innerHTML = '<div class="last-column"></div>';
      let _self = this;
      setTimeout(function () {
        _self.load();
      }, 100);
    });
  },
  created() {
    window.addEventListener("resize", this.gridRefresh);
  },
  destroyed() {
    window.removeEventListener("resize", this.gridRefresh);
  },
  methods: {
    changePage() {
      this.loading = true;
      eventBus.$emit("changePage", this.current_page);
      this.images = null;
      this.$refs.bw.innerHTML = "";
      this.$refs.bw.innerHTML = '<div class="last-column"></div>';
    },
    gridRefresh() {
      let _this = this;
      setTimeout(function () {
        _this.$refs.bw.innerHTML = "";
        _this.$refs.bw.innerHTML = '<div class="last-column"></div>';
        _this.load();
      }, 500);
    },
    imgLoaded(_id) {
      if (!this.images) this.images = [];
      this.images.push(true);
      if (this.images.length === this.sortedItems.length) {
        this.load();
        let _this = this;
        setTimeout(function () {
          _this.loading = false;
        }, 500);
      }
    },
  },
};
</script>

<style scoped>
.search-results,
.o-malleys-bar {
  background: url(~@/assets/img/dzyndzle_search.svg) no-repeat bottom;
}
.o-malley-bar {
  height: 1.5em;
  width: 100%;
  margin-bottom: 1.5em;
  margin-top: 1.5em;
  display: none;
}
.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
}
.loading {
  animation: fadeInAnimation ease 3s;
  animation-iteration-count: 1;
  animation-fill-mode: forwards;
}
@keyframes fadeInAnimation {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0.2;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Common/Grid/Grid.vue